module.exports = __webpack_public_path__ + "img/lifetime-steps-icon.209164d1.svg";